// extracted by mini-css-extract-plugin
export var container = "_do-0";
export var infoIcon = "_do-2";
export var internalLabel = "_do-3";
export var titleRowCol = "_do-1";